import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import * as actions from '@appStore/selfservice/actions';
import { ActionTypes, AgreementLinkLoad } from '@appStore/selfservice/actions';
import { AgreementService } from '@appStore/selfservice/services/agreement.service';

@Injectable()
export class AgreementEffects {
    constructor(private agreementService: AgreementService, private actions$: Actions) {}

    getAgreementLink$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ActionTypes.AgreementLinkLoad),
            exhaustMap((action: AgreementLinkLoad) => {
                return this.agreementService.getAgreementLink(action.agreementId).pipe(
                    map(link => new actions.AgreementLinkLoadSuccess(link)),
                    catchError(error => of(new actions.AgreementLinkLoadFail(error)))
                );
            })
        );
    });

    loadMyFormAgreement$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(ActionTypes.SelfServiceAgreementsLoad),
        exhaustMap(action => {
          return this.agreementService.getMySelfServiceAgreements().pipe(
            map(forms => new actions.SelfServiceAgreementsLoadSuccess(forms)),
            catchError(error => of(new actions.SelfServiceAgreementsLoadFail(error)))
          );
        })
      );
    });

    createFormAgreement$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(ActionTypes.CreateSelfServiceAgreement),
        exhaustMap((action: actions.CreateSelfServiceAgreement) => {
          return this.agreementService.createSelfServiceAgreement(action.payload).pipe(
            map(item => new actions.CreateSelfServiceAgreementSuccess(item)),
            catchError(error => of(new actions.CreateSelfServiceAgreementFail(error)))
          );
        })
      );
  });
}